import React from "react";
import Employee from "./Employee";

let EmployeeColumn = React.createClass({

    propTypes: {
        items: React.PropTypes.arrayOf(React.PropTypes.object).isRequired
    },
    render() {
        return (
                <ul className="eo-employee-column">
                    {
                        this.props.items.map((employee, i) => {
                            return (
                                <li key={`employee-${i}`} className="eo-people-grid-person">
                                    <Employee name={employee.name} imgUrl={employee.imgUrl} bwUrl={employee.bwUrl} team={employee.team} networks={employee.networks}/>
                                </li>
                            );
                        })
                    }
                </ul>
        );
    }
});

export default EmployeeColumn;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/our-story/components/EmployeeColumn.js
 **/